module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "file_019"
    }
  }, [_vm._v("Dyeing Wool")])]), _c('a', {
    attrs: {
      "id": "file_019"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "file_019"
    }
  }, [_vm._v("There is enough information on dyeing wool and other fibers to write another book. The main thing to keep in mind is that you will probably want to experiment to find out what works best for you. Some fiber artists use only natural dyes from plants. This method involves applying a mordant to the wool so that the dye can be absorbed. Other people use soft-drink mixes and icing color dye. I prefer acid dyes. Acid dyes are made from chemicals and are usually available in a powder form. The acid (white vinegar) is what helps the wool absorb the dye. The dyes come in a large variety of colors, are easy to use, and are cost-effective. As long as the wool absorbs all of the dye in the dye bath, the leftover water is safe for the environment. See the list of resources on ")]), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/file_516#file_516",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 128")]), _vm._v(" for more information on where to purchase dye. Be sure to follow the manufacturer’s safety instructions when using dyes.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bcd4e73","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_019.vue
// module id = 111
// module chunks = 0